import Image from "next/image";

export default function TrackHormoneValues() {
  return (
    <div className="bg-[#f3f4ed] pt-10 px-6 w-full md:pt-12">
      <div className="w-full max-w-[350px] md:max-w-[450px] text-center">
        <h2 className="title-32 text-[#232221] text-left mb-6">
          Track your actual hormone values with Inito!
        </h2>

        <p className="title-16 text-[#112d35] text-left mb-5">
          Unlike most ovulation tests that only give you &ldquo;yes/no&rdquo;
          results, Inito provides <strong className="font-bold tracking-[-0.2px]">real numerical values </strong>of your
          fertility hormones.
        </p>

        <p className="title-16 text-[#112d35] text-left">
          If you have irregular cycles, actual data is necessary to know exactly
          when you ovulate, and when is the best time to try to conceive.
        </p>

        <Image
          src="https://cdn.inito.com/quiz/result/ovulation.webp"
          alt="Ovulation Confirmed"
          width={250}
          height={400}
          className="block mx-auto mt-7"
        />
      </div>
    </div>
  );
}
